import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import PageHeader from '@zenbusiness/zui/PageHeader';

import { EducationTabs } from './components/Tabs';
import * as Styled from './Education.styles';

const LOCALIZED_TEXT = {
  heading: 'dashboard.learningHub.heading',
};

function Education() {
  return (
    <Styled.Root>
      <PageHeader
        title={<FormattedMessage id={LOCALIZED_TEXT.heading} />}
        slots={{
          end: <EducationTabs />,
        }}
      />
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </Styled.Root>
  );
}

export default Education;
